module.exports = __webpack_public_path__ + "static/media/logo2.0ab22959.png";